import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({

  pageWrapper: {
    padding: '2em 1em 2em',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: 'rgb(214 207 207 / 54%)',
    margin: '0 -15px'
  },

  heading: {
    fontFamily: 'Montserrat',
    fontWeight: '700',
    fontSize: '1.6rem',
    color: '#1A4664',
    textAlign: 'center',
    marginBottom: 30
  },

  subText: {
    color: '#6B6B6B',
    textAlign: 'center',
    marginBottom: '2em',
    fontSize: '1rem',
  },

  card: {
    width: '100%',
    maxWidth: '1200px',
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    padding: '1.8em',
    marginBottom: '1.5em',
     [theme.breakpoints.down('sm')]: {
      width: '90%'
     }
  },

  section: {
    display: 'flex',
    flexDirection: 'column'
  },

  cardHeading: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 600,
    fontSize: '1.0rem',
    color: '#1A1A1A',
    marginBottom: '0.5em',
    fontFamily: 'Montserrat'
  },

  icon: {
    color: '#535D6D',
    marginRight: '8px',
  },

  text: {
    fontSize: 16,
    color: '#4D4D4D',
    lineHeight: 1.6,
    fontFamily: 'Montserrat',
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
     fontSize: 12
    }
  },

  phoneNumber: {
    fontWeight: 700,
    fontSize: '1.2rem',
    color: '#1A4664',
    margin: '0.5em 0'
  },

  link: {
    color: '#1A4664',
    textDecoration: 'none',
    fontFamily: 'Montserrat'
  },

  btnRow: {
    display: 'flex',
    gap: '1em',
    marginTop: '1.2em',
  },

  primaryBtn: {
    fontWeight: 600,
    borderRadius: '8px',
    textTransform: 'none',
    fontFamily: 'Montserrat'
  },

   pageHeading: {
    color: '#1A4664',
    fontFamily: 'Montserrat',
    fontSize: '22px',
    fontWeight: '700',
    letterSpacing: '0.18px',
    lineHeight: '24px',
    marginBottom: 20,
    marginTop: 20
  },

  breadcrum: {
    paddingTop: 20,
    maxWidth: '120em',
    marginLeft: 'auto',
    marginRight: 'auto',
     [theme.breakpoints.down('sm')]: {
      paddingLeft: 20
     }
  },

   links: {
    fontSize: 14,
    color: '#4D4D4D',
    lineHeight: 1.6,
    fontFamily: 'Montserrat',
    fontWeight: 600,
    paddingTop: 20
  },

   clickHere: {
    fontWeight: '700',
    fontFamily: "Montserrat",
    fontSize: 14,
    textDecoration: 'underline',
    cursor: 'pointer'
  },

  verticalDivider: {
    margin: '0 4rem',
    backgroundColor: '#d9d9d9',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    },
  },

  line: {
    border: '1px solid #E4E4E4'
  }

}));
